export default __webpack_public_path__ + "be986580188b2d92a47bec945a9bb71e.wasm";